import React from "react";
import NarrowContainer from "components/Surfaces/NarrowContainer";
import { useAuth } from "hooks/Auth";

export default function Docs(props) {
    const auth = useAuth();

    return (
        <NarrowContainer>
            <div className="rounded-lg bg-white p-5 shadow">
                <h1 className="text-2xl font-light uppercase text-gray-800">
                    Documents & Downloads
                </h1>

                <div className="mx-auto mt-5 rounded bg-gray-100 px-2 py-4 text-center lg:w-2/3">
                    <h2 className="text-xl font-light text-gray-900">
                        Need help?
                    </h2>
                    <div className="mt-4">
                        <a
                            href="https://support.getsnworks.com"
                            className="focus:outline-none inline-flex justify-center rounded-md border border-transparent bg-green-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-green-700 focus:ring-2 focus:ring-green-500 focus:ring-offset-2"
                        >
                            Contact SNworks Support
                        </a>
                    </div>
                </div>

                <p className="prose mt-5 text-gray-800">
                    SNworks provides a number of documents that my be required
                    by your parent institution. If you have any questions,
                    please let us know!
                </p>

                <div className="mt-5 space-y-10">
                    <div>
                        <dt className="text-base font-medium text-gray-900">
                            Site Tag Sheet
                        </dt>
                        <dd className="mt-3 space-y-4 text-sm text-gray-500">
                            <p>
                                Tag sheets are generated by SNworks for every
                                site revision. Tag sheets help you determine
                                content placement on your site.
                            </p>
                            <ul className="mt-4 list-inside list-disc">
                                <li>
                                    <a
                                        href={`https://static.getsnworks.com/downloads/tag-sheets/${auth.publication.client_code}-latest.pdf`}
                                        className="text-green-700 underline"
                                    >
                                        {auth.publication.name} Tag Sheet -
                                        Latest
                                    </a>{" "}
                                    (PDF)
                                </li>
                            </ul>
                        </dd>
                    </div>
                    <div>
                        <dt className="text-base font-medium text-gray-900">
                            SNworks Site and Authoring VPAT<sup>&copy;</sup>
                        </dt>
                        <dd className="mt-3 space-y-4 text-sm text-gray-500">
                            <p>
                                VPATs are voluntary accessibility conformance
                                reports that may be required by your parent
                                institution.
                            </p>
                            <ul className="mt-4 list-inside list-disc">
                                <li>
                                    <a
                                        href="https://static.getsnworks.com/downloads/VPAT-2.4-2022-SNworks.pdf"
                                        className="text-green-700 underline"
                                    >
                                        VPAT 2.4 - Updated Mar 2022
                                    </a>{" "}
                                    (PDF)
                                </li>
                                <li>
                                    <a
                                        href="https://static.getsnworks.com/downloads/VPAT-2.0-2020-SNworks.pdf"
                                        className="text-green-700 underline"
                                    >
                                        VPAT 2.0 - Updated Oct 2020
                                    </a>{" "}
                                    (PDF)
                                </li>
                            </ul>
                        </dd>
                    </div>
                    <div>
                        <dt className="text-base font-medium text-gray-900">
                            CEO Local Development
                        </dt>
                        <dd className="mt-3 space-y-4 text-sm text-gray-500">
                            <p>
                                Local development access gives you the ability
                                to manage your site's templates directly.
                            </p>
                            <ul className="mt-4 list-inside list-disc">
                                <li>
                                    <a
                                        href="https://docs.getsnworks.com/front-end/development/"
                                        className="text-green-700 underline"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        Local development - Getting started
                                    </a>
                                </li>
                            </ul>
                        </dd>
                    </div>
                    <div>
                        <dt className="text-base font-medium text-gray-900">
                            CEO Connect
                        </dt>
                        <dd className="mt-3 space-y-4 text-sm text-gray-500">
                            <p>
                                Download CEO Connect plugins for InCopy/InDesign
                                CC, all versions.
                            </p>
                            <ul className="mt-4 list-inside list-disc">
                                <li>
                                    <a
                                        href="https://static.getsnworks.com/connect/CEOConnect_InCopy_1.4.0.zxp.zip"
                                        className="text-green-700 underline"
                                    >
                                        InCopy CC Connect
                                    </a>{" "}
                                    (ZIP)
                                </li>
                                <li>
                                    <a
                                        href="https://static.getsnworks.com/connect/CEOConnect_InDesign_1.4.0.zxp.zip"
                                        className="text-green-700 underline"
                                    >
                                        InDesign CC Connect
                                    </a>{" "}
                                    (ZIP)
                                </li>
                            </ul>
                        </dd>
                    </div>
                </div>
            </div>
        </NarrowContainer>
    );
}
